import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table } from 'antd';
import DefaultLayout from './DefaultLayout';
import { Navigate } from 'react-router-dom';

function AllBookings() {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const userData = JSON.parse(localStorage.getItem('user'));
    const user = userData?.user || userData;

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axios.get('https://luxurylifelimo.onrender.com/api/bookings/getallbookings');
                setBookings(response.data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }

        if (user?.role === 'admin') {
            fetchData();
        }
    }, [user]);

    if (!user || user.role !== 'admin') {
        return <Navigate to="/" />;
    }

    const columns = [
        {
            title: 'USER',
            dataIndex: 'user',
            render: user => user?.username || user?.email
        },
        {
            title: 'CAR',
            dataIndex: 'car',
            render: car => car ? car.make : 'Car deleted'
        },
        {
            title: 'BOOKING TIME',
            dataIndex: 'bookedTimeSlots',
            render: slots =>
                Array.isArray(slots) && slots.length > 0
                    ? slots.map(slot => `${slot.from} - ${slot.to}`).join(', ')
                    : 'N/A'
        },
        {
            title: 'PICKUP LOCATION',
            dataIndex: 'pickupLocation',
            render: loc => loc || 'N/A'
        },
        {
            title: 'DROPOFF LOCATION',
            dataIndex: 'dropoffLocation',
            render: loc => loc || 'N/A'
        },
        {
            title: 'TOTAL AMOUNT',
            dataIndex: 'totalAmount'
        },
    ];

    return (
        <DefaultLayout>
            <h2>All Bookings</h2>
            <Table
                columns={columns}
                dataSource={bookings}
                rowKey="_id"
                loading={loading}
            />
        </DefaultLayout>
    );
}

export default AllBookings;
